module.exports = __webpack_public_path__ + "static/media/hr-core.6ee0fa3e.png";